import type { NextgenDOMPurifyConfig } from '@nextgen-web-framework/all';
import { CMSDataType } from '../../../utils/common';

export interface SanityConfig {
  sanitize?: boolean;
  sanitizationConfig?: NextgenDOMPurifyConfig;
}
export type ComponentRegistry = {
  [key: string]: React.ElementType;
};

export interface AbstractComponentPropTypes {
  componentType: string;
}
export interface SanitizeComponentPropTypes extends AbstractComponentPropTypes, SanityConfig {}

export type ComponentTransformerRegistry = {
  [key: string]: (data: CMSDataType) => AbstractComponentPropTypes;
};

export type PageTransformerRegistry = {
  [key: string]: (data: CMSDataType) => CMSDataType;
};

export enum ComponentType {
  product_carousal_banner = 'product_carousal_banner',
  default = 'default',
  me_panel = 'me_panel',
  promotion_overview = 'promotion_overview',
  resource_overview = 'resource_overview',
  product_carousel = 'product_carousel',
  a_point_product_carousel = 'a_point_product_carousel',
}
